import React from "react";

export const CircleTick = () => {
    return (
        <>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.21457 17.8962C14.0087 17.8962 17.9291 14.1555 17.9291 9.49996C17.9291 4.84443 14.0087 1.10376 9.21457 1.10376C4.42046 1.10376 0.5 4.84443 0.5 9.49996C0.5 14.1555 4.42046 17.8962 9.21457 17.8962Z" stroke="#0B42FF" />
                <path d="M7.63728 11.0479L5.72119 9.22778L4.89844 10.0093L7.63728 12.6111L13.2854 7.24568L12.4627 6.46411L7.63728 11.0479Z" fill="#0B42FF" />
            </svg>

        </>
    )
}